export default __webpack_public_path__ + "static/media/lets-go-img.1dd624c4.png";